export interface IDocumentAccentColour {
  key: string;
  name: string;
}

export const DOCUMENT_ACCENT_COLOURS: IDocumentAccentColour[] = [
  { key: '#1f4e79', name: 'Navy' },
  { key: '#1f6b4a', name: 'Green' },
  { key: '#8b3a3a', name: 'Burgundy' },
  { key: '#0f6e6e', name: 'Teal' },
  { key: '#5c4a1f', name: 'Bronze' },
  { key: '#3d4a57', name: 'Slate' },
];

export const DEFAULT_DOCUMENT_ACCENT_COLOUR = '#1f4e79';
